/* eslint-disable camelcase */
import Vue from 'vue'
import {
  ValidationObserver,
  ValidationProvider,
  extend,
  setInteractionMode,
} from 'vee-validate'
import {
  required,
  alpha_spaces,
  email,
  confirmed,
  min,
  numeric,
  max,
  digits,
} from 'vee-validate/dist/rules'

setInteractionMode('lazy')

extend('required', {
  ...required,
  message: 'Il campo è obbligatorio',
})
extend('confirmed', {
  ...confirmed,
  message: 'Le password non corrispondono',
})

extend('strongPassword', {
  message() {
    return `La password deve contenere almeno una lettera minuscola, una maiuscola, un numero e un carattere speciale`
  },
  validate(value) {
    // Regex aggiornata per accettare QUALSIASI carattere speciale/punteggiatura (non alfanumerico)
    // Vecchia: (?=.*[!@#$%^&*])
    // Nuova: (?=.*[\W_]) -> \W significa "non-word character" (tutto tranne a-z, A-Z, 0-9), _ è incluso per coprire l'underscore.
    const regex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\\W_])')
    return regex.test(value)
  },
})

extend('min', {
  ...min,
  message: 'La password è troppo corta',
})

// Aggiunte regole mancanti rispetto al set standard ma utili
extend('max', max)
extend('numeric', numeric)
extend('digits', digits)

extend('alpha_spaces', {
  ...alpha_spaces,
  message: 'Il campo può contenere solo lettere',
})

extend('email', {
  ...email,
  message: 'Il campo deve contenere un email valida',
})

extend('phone', {
  message() {
    return `Inserisci un numero di telefono valido`
  },
  validate(value) {
    // Mantengo la validazione custom che c'era nel file originale
    const regex = /^(?:[0-9+] ?){0,1}(?:[0-9] ?){7,}$/
    return value.toString().match(regex)
  },
})

Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)
